import { GoogleWebfontsWeights } from '../googleWebfontHelper/use_google_webfonts_list'
import { useCallback, useEffect } from 'react'

// Make sure the selected weight is avaliable for the currently selected font.
export const useFixFontToWeightMissmatch = ({
  currentFontWeight = '',
  setFieldValue,
  googleWebfontWeights,
}: {
  currentFontWeight?: string
  setFieldValue: (name: string, value: string) => void
  googleWebfontWeights: GoogleWebfontsWeights
}) => {
  const setWeight = useCallback((weight: string) => setFieldValue('fontWeight', weight), [setFieldValue])

  useEffect(() => {
    if (!googleWebfontWeights || !googleWebfontWeights[0]) return setWeight('400')
    if (googleWebfontWeights.includes(currentFontWeight)) return setWeight(currentFontWeight)
    if (googleWebfontWeights.includes('regular')) return setWeight('regular')
    return setWeight(googleWebfontWeights[0])
  }, [currentFontWeight, googleWebfontWeights, setWeight])
}
